<template>
  <div id="app" class="bg" :style="styleCheck ? 'padding-top:0' : ''">
    <div class="header" id="header">
      <div class="float-left" v-if="!styleCheck">
        <img
          src="./assets/logo.png"
          class="d-inline-bolck"
          style="
            border-right: 2px solid #000;
            width: 160px;
            padding-right: 10px;
          "
          alt=""
        />
        <span
          style="
            font-size: 24px;
            margin-left: 10px;
            color: #000;
            vertical-align: bottom;
          "
          >Project Management System</span
        >
        <!-- <span style="font-size: 24px; margin-left: 10px; color: #000"
          >项目管理系统 Project Management System</span
        > -->
      </div>
      <div class="float-left" v-if="styleCheck">
        <img
          src="./assets/logo2.png"
          class="d-inline-bolck"
          style="
            border-right: 2px solid #ccc;
            width: 160px;
            padding-right: 10px;
          "
          alt=""
        />
        <span
          style="
            font-size: 24px;
            margin-left: 10px;
            color: #ddd;
            vertical-align: bottom;
          "
          >Project Management System</span
        >
      </div>
      <el-button
        type="text"
        class="float-right"
        style="font-size: 18px; color: #000"
        @click="logout"
        v-if="!styleCheck"
        >Logout</el-button
      >
      <el-button
        type="text"
        class="float-right"
        style="font-size: 18px; color: #000; margin-right: 20px"
        @click="showHelp"
        v-if="home_help"
        >Help</el-button
      >
      <el-dropdown
        v-if="user_help"
        class="float-right"
        style="font-size: 18px; color: #000; margin: 10px 20px 0 0"
        @command="handleCommand"
      >
        <span class="el-dropdown-link">
          Help video<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1"
            >1.登录与查看基因表达分布</el-dropdown-item
          >
          <el-dropdown-item command="2">2.查看细胞信息</el-dropdown-item>
          <el-dropdown-item command="3">3.基因表达对比</el-dropdown-item>
          <el-dropdown-item command="4">4.基因共表达</el-dropdown-item>
          <el-dropdown-item command="5">5.单个基因表达作图</el-dropdown-item>
          <el-dropdown-item command="6">6.多个基因作图</el-dropdown-item>
          <el-dropdown-item command="all"
            >全功能简介</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <router-view />
    <!-- <el-dialog title="HELP" :visible.sync="dialogVisible" width="80%">
      <img src="./assets/home_help.png" alt="" class="help_img" />
    </el-dialog> -->
  </div>
</template>

<script>
import API from "@/services/user";
export default {
  name: "App",
  data() {
    return {
      styleCheck: false,
      home_help: false,
      user_help: false
    };
  },
  watch: {
    $route: {
      handler(route) {
        let that = this;
        if (route.name == "adminlogin" || route.name == "login") {
          that.styleCheck = true;
        } else {
          that.styleCheck = false;
        }
        if (
          route.name == "adminlogin" ||
          route.name == "super" ||
          route.name == "administrator" ||
          route.name == "manager" ||
          route.name == "engineer"
        ) {
          that.home_help = true;
        } else {
          that.home_help = false;
        }
        if (route.name == "home") {
          that.user_help = true;
        } else {
          that.user_help = false;
        }
      }
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    logout() {
      // if (this.$router.currentRoute.name == "home") {
      //   API.client_logout().then((res) => {
      //     if (res.code == 200) {
      //       this.$router.push("/");
      //     }
      //   });
      // } else {
      API.logout().then(res => {
        if (res.code == 200) {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("user_id");
          this.$router.push("/");
        }
      });
      // }
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let header = document.getElementById("header");
      if (!this.styleCheck) {
        if (scrollTop > 10) {
          header.className = "w-100 header headerBG";
        } else {
          header.className = "w-100 header";
        }
      }
    },
    showHelp() {
      const newpage = this.$router.resolve({
        path: "/instructions",
        name: "/instructions"
      });
      window.open(newpage.href, "_blank");
    },
    handleCommand(command) {
      window.open("http://120.48.69.30:4058/video/" + command + ".mp4");
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-table .el-table__fixed {
  height: auto !important;
  bottom: 11px;
}
.el-table .el-table__fixed-right {
  height: auto !important;
  bottom: 11px;
}
::-webkit-scrollbar {
  width: 0.4rem;
  height: 11px;
  background: #fff;
}
::-webkit-scrollbar-track {
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  background: rgba(54, 129, 216, 0.5);
  transition: all 0.2s;
  border-radius: 0.25rem;
}
.bg {
  min-height: 100vh;
  height: 100%;
  padding-top: 65px;
  background: url(./assets/123.jpg) no-repeat;
  background-size: cover;
}
.header {
  position: fixed;
  top: 0;
  z-index: 99;
  padding: 10px 30px;
  width: 100%;
}
.headerBG {
  background-color: rgb(206, 206, 206);
}
.w-90 {
  width: 90%;
}
.help_img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue